import tiles from "url:./kenney-pixel-v4.png";
import Colors from "./core/Colors";

export const VH = 36;
export const VW = 80;

export const TILE_TYPES = {
  EMPTY: ".",
  WALL: "#",
};

export const DOWN_ARROW = String.fromCharCode(127);
export const EMPTY_HEART = String.fromCharCode(128);
export const HALF_HEART = String.fromCharCode(129);
export const FULL_HEART = String.fromCharCode(130);

export const EMPTY_HUNGER = String.fromCharCode(131);
export const HALF_HUNGER = String.fromCharCode(132);
export const FULL_HUNGER = String.fromCharCode(133);

export const SCROLL = String.fromCharCode(134);
export const POTION = String.fromCharCode(135);
export const RATION = String.fromCharCode(136);

export const STAIRS = String.fromCharCode(137);
export const COINS = String.fromCharCode(138);

const tileSet = document.createElement("img");
tileSet.src = tiles;

const tileSetPromise = new Promise((r) => (tileSet.onload = r));
const T_SIZE_H = 20;
const T_SIZE_V = 24;
const START_C = 32;
const END_C = 138;

const tileMap: Record<string, [number, number]> = {};
//Add Common symbols and alpha numerics
for (let i = START_C; i <= END_C; i++) {
  tileMap[String.fromCharCode(i)] = [
    (i % 16) * T_SIZE_H + 2,
    Math.floor((i - 32) / 16) * T_SIZE_V + 2,
  ];
}
tileMap[" "] = [0, 0];

export const getTileOptions = async () => {
  await tileSetPromise;
  return {
    layout: "tile-gl",
    tileColorize: true,
    fg: Colors.EGGSHELL,
    bg: Colors.OFF_BLACK,
    tileWidth: 16,
    tileHeight: 20,
    tileMap,
    tileSet,
  } as const;
};
